import { getRatingColor, getRatingString } from 'src/utils/constants';
import {
	getCommissionPriorityLabel,
	getSalesTargetLabel,
	isCommissionSalesTarget,
	toCommissionPriorityEnum,
} from 'src/utils/mappers/companySalesTarget.mapper';
import { mapLinks } from './helpers/mapLinks';

const ratingFields = [
	{
		key: 'wedding',
		label: 'Свадьба',
		withAuto: true,
	},
	{
		key: 'birthday',
		label: 'День рождения',
		withAuto: true,
	},
	{
		key: 'corporative',
		label: 'Корпоратив',
	},
	{
		key: 'newYear',
		label: 'Новый год',
		withAuto: true,
	},
	{
		key: 'graduation',
		label: 'Выпускной',
	},
];

const INTERNAL_SITE_LABELS = {
	gorko: 'Gorko',
	bpm: 'BPM',
	wiki: 'Wiki',
};

const mapInternalSites = (sitesInternal) => {
	if (!sitesInternal) return [];

	return Object.entries(INTERNAL_SITE_LABELS)
		.filter(([key]) => sitesInternal[key])
		.map(([key, label], index) => ({
			id: `internal-site-${key}-${index}`,
			label,
			link: { to: sitesInternal[key] },
		}));
};

const mapCustomFieldOptions = (customFields = []) =>
	(customFields ?? [])
		.filter((field) => field?.type && field?.values?.length)
		.map((field, index) => {
			const links = mapLinks(field.values);

			return links.length
				? {
					id: `params-list-custom-${index}`,
					type: 'link',
					label: field.type,
					payload: {
						links,
						direction: 'column',
					},
				}
				: {
					id: `params-list-custom-${index}`,
					label: field.type,
					payload: { value: '—' },
				};
		});

export const companySideAreaParams = (company, { onEditWorth } = {}) => {
	const knownFrom = company.params?.knownFrom;
	const worth = company.worth;
	const links = [
		...mapLinks(company.params?.sitesExternal),
		...mapInternalSites(company.params?.sitesInternal),
	];
	const emails = mapLinks(company.params?.email, 'email');
	const customFieldOptions = mapCustomFieldOptions(
		company.params?.customFields,
	);
	const worthOptions = [
		{
			id: 'params-list-2-rating',
			label: 'Ценность',
			payload: {
				value: worth?.value ?? worth?.valueAuto,
			},
			type: 'rating',
		},
		{
			id: 'params-list-2-grades',
			label: 'Оценка',
			type: 'grade',
			payload: {
				grades: ratingFields.map(({ key, label, withAuto }) => {
					const score = withAuto
						? (worth?.[key] ?? worth?.[`${key}Auto`])
						: worth?.[key];

					return {
						label: label,
						value: getRatingString(score),
						status: getRatingColor(score),
					};
				}),
			},
		},
		{
			id: 'params-list-2-sales-target',
			label: 'Цель продажи',
			payload: { value: getSalesTargetLabel(company.salesTarget) },
		},
	];

	if (
		isCommissionSalesTarget(company.salesTarget) &&
		toCommissionPriorityEnum(company.commissionPriority)
	) {
		worthOptions.push({
			id: 'params-list-2-commission-priority',
			label: 'Приоритет комиссии',
			payload: {
				value: getCommissionPriorityLabel(company.commissionPriority),
			},
		});
	}

	return {
		id: 'params',
		label: 'Параметры',
		items: [
			{
				id: 'params-list',
				data: {
					options: [
						{
							id: 'params-list-gorko-id',
							label: 'Gorko ID',
							payload: { value: company.gorkoId ?? '—' },
							valueClipboard: company.gorkoId
								? String(company.gorkoId)
								: null,
						},
						{
							id: 'params-list-city',
							label: 'Город',
							payload: { value: company.city?.name },
						},
						{
							id: 'params-list-known-from',
							label: 'Известен с',
							payload: {
								value: knownFrom
									? new Date(knownFrom).toLocaleDateString(
										'ru-RU',
										{
											day: 'numeric',
											month: 'short',
											year: 'numeric',
										},
									)
									: '—',
							},
						},
						links.length
							? {
								id: 'params-list-links',
								type: 'link',
								label: 'Ссылки',
								payload: {
									links,
								},
							}
							: {
								id: 'params-list-links',
								label: 'Ссылки',
								payload: { value: '—' },
							},
						emails.length
							? {
								id: 'params-list-email',
								type: 'link',
								label: 'Эл. почта',
								payload: {
									links: emails,
									direction: 'column',
								},
							}
							: {
								id: 'params-list-email',
								label: 'Эл. почта',
								payload: { value: '—' },
							},
						...customFieldOptions,
					].filter(Boolean),
				},
			},
			{
				id: 'params-list-2',
				plate: onEditWorth ? { onEdit: onEditWorth } : undefined,
				data: {
					options: worthOptions,
				},
			},
		],
	};
};
